var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "voice-request-list-component" }, [
    _c("div", { staticClass: "voice-request-list" }, [
      _c(
        "div",
        { staticClass: "voice-request-list-header" },
        [
          _c("p", { staticClass: "voice-request-list-title" }, [
            _vm._v(_vm._s(_vm.$t("voice.list.title"))),
          ]),
          _c("GrmCloseBtn", {
            attrs: { small: "" },
            on: { click: _vm.onClickClose },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "voice-request-list-body" },
        [
          _vm.reqSpeakUserList.length > 0 || _vm.reqSpeakMsgList.length > 0
            ? _c("perfect-scrollbar", [
                _c(
                  "ul",
                  { staticClass: "voice-request-item-wrapper" },
                  [
                    _vm._l(_vm.reqSpeakUserList, function (reqSpeakUser) {
                      return _c(
                        "li",
                        {
                          key: reqSpeakUser.userId,
                          staticClass: "voice-request-item",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "voice-request-item-text" },
                            [
                              _c(
                                "p",
                                { staticClass: "voice-request-item-title" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getUsername(reqSpeakUser.userId))
                                  ),
                                ]
                              ),
                              _c(
                                "p",
                                { staticClass: "voice-request-item-time" },
                                [_vm._v(_vm._s(reqSpeakUser.date))]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "voice-request-button-container" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "voice-request-button accept",
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmRequestSpeak({
                                        reqSpeakId: reqSpeakUser.reqSpeakId,
                                        userId: reqSpeakUser.userId,
                                        reject: false,
                                      })
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.apply")))]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "voice-request-button refuse",
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmRequestSpeak({
                                        reqSpeakId: reqSpeakUser.reqSpeakId,
                                        userId: reqSpeakUser.userId,
                                        reject: true,
                                      })
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.reject")))]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm._l(_vm.reqSpeakMsgList, function (reqSpeakMsg) {
                      return _c(
                        "li",
                        {
                          key: reqSpeakMsg.userId,
                          staticClass: "voice-request-msg",
                        },
                        [
                          _vm._v(" " + _vm._s(reqSpeakMsg.msg) + " "),
                          _c("span", { staticClass: "voice-request-date" }, [
                            _vm._v(_vm._s(reqSpeakMsg.date)),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _c("div", { staticClass: "voice-request-no-data" }, [
                _vm._v(_vm._s(_vm.$t("voice.list.notExist"))),
              ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }